<template>
  <div class="usuarios-cadastro">
    <div class="mt-2">
      <v-btn icon :to="`/gerencial/vincular-perfil/`">
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </div>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" dark class="mb-3">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <v-card class="pa-3 mt-2">
      <form @submit.prevent="onSubmit">
        <Select label="Perfil" :options="optionsPerfil" v-model="form.identificadorperfil" :v="$v.form.identificadorperfil" @change="loadSubPerfil" :disabled="true"/>
        <Select label="Sub Perfil" :options="optionsSubPerfil" v-model="form.identificadorperfilsub" :v="$v.form.identificadorperfilsub" :disabled="loading"/>

        <div class="user-bloco">
          <div class="user-notification">
            <v-tooltip bottom>
              <template v-slot:activator="{on, attrs}">
                <v-icon v-bind="attrs" v-on="on"  size="16" style="vertical-align: top">notification_important</v-icon>
              </template>
              <span class="text-caption white--text">Usar este campo quando o perfil for professor</span>
            </v-tooltip>
          </div>
          <SelectBuscaApi
            class="busca-user-perfil"
            id="cdmatric"
            route="ei/professor/select"
            fieldSearch="nmfuncion"
            label="Professor"
            :disabled="loading"
            :v="$v.form.cdmatric"
            :value="form.cdmatric"
            @retorno="retorno">
            <template slot-scope="propSlot">
              Matrícula: {{ propSlot.item.cdmatric }} - Nome: {{ propSlot.item.nmfuncion }}
            </template>
          </SelectBuscaApi>
        </div>

        <div class="mt-3" style="text-align: right">
          <v-btn type="submit" :loading="loading" small dark color="teal" class="rounded-sm font-weight-regular" width="90px">Salvar</v-btn>
        </div>
      </form>
    </v-card>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import { required, integer } from 'vuelidate/lib/validators';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import SelectBuscaApi from '@/components/SelectBuscaApi';
import store from '@/store';
import { mapGetters, mapState, mapMutations } from 'vuex';

const AtenaPerfilRepository = RepositoryFactory.get('vincularPerfil');
const AtenaSubPerfilRepository = RepositoryFactory.get('atenaSubPerfil');
const AtenaUsuarioRepository = RepositoryFactory.get('atenaUsuario');

const setFormInicial = (idUser) => ({
  identificadorperfil: '',
  identificadorperfilsub: '',
  cdpessoal: '',
  cdmatric: '',
  identificadorusuario: idUser,
  indicadelecaoperfil: 'S',
});

export default {
  name: 'VincularPerfilCadastro',
  components: {
    SelectBuscaApi,
  },
  props: {
    idUsuario: [Number, String],
    idUsuarioPerfil: [Number, String],
  },
  data() {
    return {
      form: setFormInicial(this.idUsuario),
      usuario: {},
      loading: false,
      msgArrayError: [],
      submitText: '',
      snackbar: false,
      optionsPerfil: [],
      optionsSubPerfil: [],
      perfis: [],
    };
  },
  validations: {
    form: {
      identificadorperfil: { integer, required },
      identificadorusuario: { integer, required },
      identificadorperfilsub: { integer },
      cdpessoal: { integer },
      cdmatric: { integer },
    },
  },
  async beforeRouteEnter(to, from, next) {
    try{
     const { data } = await AtenaPerfilRepository.getSelectPerfil();
      // console.log('data=', data);
      // console.log('to.params =', to.params);
      // console.log('to.params.idUsuario=', to.params.idUsuario);
      // console.log('to.params.idUsuarioPerfil=', to.params.idUsuarioPerfil);
      let editar = {};
      if(to.params.idUsuarioPerfil) {
        editar = await AtenaPerfilRepository.getUsuarioPerfil(to.params.idUsuario, to.params.idUsuarioPerfil);
        //console.log('editar=', editar);
      }

      next(vm => {
        vm.montarPerfil(data.results);
        if(to.params.idUsuarioPerfil) { vm.load(editar.data.results); }
      });
    }
    catch(e){
      next(`/gerencial/vincular-perfil/${to.params.idUsuario}/perfil`);
    }
  },
  created() {
    console.log('created store =', store.getters.userDadosPerfilAtual);
    this.form.identificadorperfil = store.getters.userDadosPerfilAtual.identificadorperfil;
    this.$Progress.finish();
  },
  computed: {
    ...mapGetters(['getAnoSistema',  'userDadosPerfilAtual', 'userProfessor', 'profiles'])

  },
  methods: {
    montarPerfil(perfis) {
      this.perfis = perfis;

      this.optionsPerfil = perfis.map((key) =>({ value: key.identificadorperfil, text: key.nomeperfil }));
      this.optionsPerfil.unshift({ value: null, text: '' });

      if(this.idUsuarioPerfil) { this.loadSubPerfil(); }
    },
    async loadSubPerfil() {
      this.form.identificadorperfilsub = '';
      this.optionsSubPerfil = [];
      if(this.form.identificadorperfil === '') { return; }
      try {
        this.loading = true;
        const { data } = await AtenaSubPerfilRepository.getSelectSubPerfil({
          identificadorperfil: this.form.identificadorperfil,
        });

        this.optionsSubPerfil = data.results.map((key) => ({ value: key.identificadorperfilsub, text: key.nomesubperfil }));
        this.optionsSubPerfil.unshift({ value: null, text: '' });
      } finally {
        this.loading = false;
      }
    },
    load(data) {
      this.form = { ...data.userPerfil };
      this.usuario = data.user;
    },
    retorno(dados) {
      this.form.cdpessoal = '';
      this.form.cdmatric = '';

      if(dados) {
        this.form.cdpessoal = dados.cdpessoal;
        this.form.cdmatric = dados.cdmatric;
      }
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) { return; }

      try {
        this.loading = true;
        this.msgArrayError = [];
        const funcao = (this.idUsuarioPerfil)? 'put' : 'post';
        console.log('this.form =', this.form);
        const { data } = await AtenaPerfilRepository[`${funcao}UsuarioPerfil`](

         {...this.form},

        );

        this.submitText = data.message;
        this.snackbar = true;

        setTimeout(() => {
          this.$root.$router.push({
           // path: `/atena/usuario/${this.idUsuario}/perfil`,
            path: `/gerencial/vincular-perfil/`,
          });
        }, 1000);
      } catch(error) {
        if (error.response && error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>

<style lang="scss">
.usuarios-cadastro {
  margin: 0px 15px;

  .busca-user-perfil {
    width: 60%;
  }

  .user-bloco {
    position: relative;
    margin-top: 17px;
  }

  .user-notification {
    position: absolute;
    top: -19px;
  }
}
</style>
